// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","before":"Loader_before__zkuvW","after":"Loader_after__j9qAH"};